import { QueryClient } from '@tanstack/react-query'

/** Shared query client, here rather than main.tsx so the axios layer can reset the cached session on a 401 without a circular import. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // A 401/403 will not fix itself by retrying.
      retry: (failureCount, error) => {
        const status = (error as { response?: { status?: number } }).response?.status
        if (status === 401 || status === 403) return false
        return failureCount < 2
      },
    },
  },
})
